export default function blurBackgroundEnabled() {
  if (import.meta.env.TEST) return true;
  const canvas = document.createElement("canvas");
  canvas.style.display = "none";
  const context = canvas.getContext("2d");

  return !!(context && typeof context.filter !== "undefined");
}
